interface Props {
  node: Record<string, unknown>;
  readOnly?: boolean;
  onChange: (patch: Record<string, unknown>) => void;
}

export default function WaypointNodeConfig({ node, readOnly, onChange }: Props) {
  return (
    <section className="space-y-3 rounded-lg border border-border bg-surface/40 p-4">
      <h3 className="panel-section-title">Waypoint</h3>
      <p className="text-sm text-text-muted">
        Waypoints guide route geometry. Products pass through without changing type
        or volume.
      </p>
      <label className="flex items-center gap-2 text-sm text-text-muted">
        <input
          type="checkbox"
          disabled={readOnly}
          checked={node.display_label !== false}
          onChange={(e) => onChange({ display_label: e.target.checked })}
        />
        Show label on canvas
      </label>
    </section>
  );
}
